// View-rotate controls — two little arrows that snap the isometric camera a
// quarter-turn left/right (same action as the Q/E keys). Mouse/touch players get
// the feature without needing the keyboard. Sits just above the UI minimap.
// Emits Events.RotateView; heroController owns the actual camera math.

import { Events, emit } from './eventBus.js'

export function mountViewRotateControls() {
  if (document.querySelector('.view-rotate')) return // idempotent

  const wrap = document.createElement('div')
  wrap.className = 'view-rotate'
  wrap.innerHTML = `
    <button class="view-rotate__btn" data-dir="-1" title="Rotate view left (Q)" aria-label="Rotate view left">⟲</button>
    <button class="view-rotate__btn" data-dir="1" title="Rotate view right (E)" aria-label="Rotate view right">⟳</button>
  `
  wrap.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-dir]')
    if (!btn) return
    emit(Events.RotateView, { dir: Number(btn.dataset.dir) })
  })
  document.body.appendChild(wrap)
}
